import { render, staticRenderFns } from "./StudentAttendance.vue?vue&type=template&id=ad0c6c30&scoped=true&"
import script from "./StudentAttendance.vue?vue&type=script&lang=js&"
export * from "./StudentAttendance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad0c6c30",
  null
  
)

export default component.exports